import LoaderPage from "src/components/Loader/LoaderPage";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import Layout from "src/router/AuthenticatedRouter/Layout";
import { ReactComponent as Plus } from "src/assets/svg/+.svg";
import { ReactComponent as PC } from "src/assets/svg/pc.svg";
import Button from "src/components/Button";
import { useEffect, useState } from "react";
import AtsJobsPage from "./jobs";
import useLoader from "src/hooks/useLoader";
import { getAtsMagicLink } from "src/network/company_ats";
import { openInNewTab } from "src/utils/urls";
import useTabActive from "src/hooks/utils/useTabActive";
import { getClient } from "src/redux/slices/client";
import ConstraintModal from "src/components/Modal/ConstraintModal";
import { useNavigate } from "react-router-dom";
import { customToast } from "src/utils/toast";

const AtsPage = () => {
  const navigate = useNavigate();
  const client = useAppSelector((r) => r.client.client);
  const enabled = client?.Company?.UsageConstraints?.ats_enabled;
  const ats = client?.Company.Ats;
  const dispatch = useAppDispatch();
  const activeTab = useTabActive();
  const [refreshing, setRefreshing] = useState<boolean>(false);
  const [mergeUrl, setMergeUrl] = useState<string>();
  const openUrl = () => openInNewTab(mergeUrl || "");
  const { ldng: fetchLink, loading: fetching } = useLoader(
    async () => {
      const link = await getAtsMagicLink();
      setMergeUrl(link);
    },
    { errorMsg: "Error fetching magic link" }
  );

  useEffect(() => {
    if (client && !ats && enabled) fetchLink();
  }, [ats]);

  const refreshClient = async () => {
    setRefreshing(true);
    customToast({ message: "It might take some minutes to sync your ats.", type: "success" });
    await dispatch(getClient());
    setRefreshing(false);
  };

  useEffect(() => {
    // If we have a url it means they could be linking the account and comming back to this tab
    if (mergeUrl && activeTab) refreshClient();
  }, [activeTab]);

  if (ats) return <AtsJobsPage />;

  return (
    <Layout
      title={`Applicant Tracking System`}
      rightChildren={
        <Button
          onClick={openUrl}
          loading={fetching || refreshing}
          disabled={!mergeUrl}
          className="!rounded-full !py-4 !px-6 !h-fit"
          variant="white_blue"
          shapeVariant={2}
        >
          <Plus className="mr-[10px] h-6 w-6" /> Connect New ATS
        </Button>
      }
    >
      {refreshing ? (
        <LoaderPage />
      ) : (
        <div className="h-full w-full flex flex-col text-center gap-[29px] items-center justify-center">
          <PC className="w-[210px]" />
          <p className="font-semibold text-xl">No connected ATS systems</p>
          <p className="w-[460px] text-base text-[#8A8A8A] font-medium leading-[36px]">
            There are no connected ATS systems currently to access. Connect your Applicant Tracking
            Systems to centralize your job and candidate data here.
          </p>
          <Button
            onClick={openUrl}
            loading={fetching}
            disabled={!mergeUrl}
            className="!rounded-full !py-4 !px-6 !h-fit"
            shapeVariant={2}
          >
            <Plus className="mr-[10px] stroke-white h-6 w-6" /> Connect New ATS
          </Button>
        </div>
      )}

      {/* Modals */}
      <ConstraintModal
        variant="ats_enabled"
        open={enabled === false}
        onClose={() => navigate("/usage")}
      />
    </Layout>
  );
};

export default AtsPage;
